"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSessionStorage = exports.MbSession = void 0;
/* eslint-disable complexity */
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const events_1 = require("../../../security/events");
const storage_1 = require("./storage");
Object.defineProperty(exports, "MbSessionStorage", { enumerable: true, get: function () { return storage_1.MbSessionStorage; } });
class MbSession extends web_ui_security_1.BaseSession {
    constructor(storage) {
        super(storage);
        this.updateData = (newData) => {
            super.updateData(newData);
            (0, events_1.publishUpdatedDataSessionEvent)(newData);
        };
        this.doRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const actualSessionInfo = {
                    refreshToken: this.getData()?.refreshToken,
                    username: this.getData()?.username,
                };
                //TODO: Logic to make recalls
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/refresh-token`, actualSessionInfo);
                //TODO: add DDD architecture to avoid endpoints and transformations here
                const newSessionData = {
                    accessToken,
                    sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                    expiresIn,
                    refreshToken: refreshToken ?? actualSessionInfo.refreshToken,
                    username: this.getData()?.username ?? '',
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                    customerSessionId: this.getData()?.customerSessionId ?? '',
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
        this.isSessionExpired = (sessionData) => {
            if (sessionData.timeOutStamp) {
                return sessionData.timeOutStamp <= Date.now();
            }
            return false;
        };
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken && sessionData.refreshToken && sessionData.username && !this.isSessionExpired(sessionData)) {
                return true;
            }
            return false;
        };
        this.xhr = null;
    }
    setXHR(newXhr) {
        this.xhr = newXhr;
    }
    initSession(initData) {
        super.initSession(initData);
        (0, events_1.publishUpdatedDataSessionEvent)(initData);
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback);
    }
    onUpdatedData(callback) {
        return (0, events_1.subscribeUpdatedDataSessionEvent)(callback);
    }
}
exports.MbSession = MbSession;
//# sourceMappingURL=index.js.map